"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IbETHOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var IbETHOracleFactory = /** @class */ (function (_super) {
    __extends(IbETHOracleFactory, _super);
    function IbETHOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    IbETHOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    IbETHOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    IbETHOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    IbETHOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    IbETHOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return IbETHOracleFactory;
}(contracts_1.ContractFactory));
exports.IbETHOracleFactory = IbETHOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "CHAIN_LINK_DECIMALS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "ibETH",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
